<script setup lang="ts">
import { onBeforeUnmount } from 'vue'

import { useInsightActionStore } from '../stores/insightActionStore'

const store = useInsightActionStore()

onBeforeUnmount(() => store.closePanel())
</script>

<template>
  <div
    class="insight-action-panel"
    :data-mode="store.mode"
    :data-step="store.mode === 'act' ? store.step : null"
  >
    <slot v-if="store.mode === 'read'" name="read" />

    <template v-else-if="store.mode === 'act'">
      <slot v-if="store.step === 'select'" name="select" />
      <slot v-else-if="store.step === 'confirm'" name="confirm" />
      <slot v-else-if="store.step === 'progress'" name="progress" />
      <slot v-else name="result" />
    </template>

    <slot v-else name="history" />
  </div>
</template>
